import React from 'react'
import { connect } from 'react-redux'
import SearchBar from '../../SearchBar'
import DashboardActionBar from '../../DashboardActionBar'
import SortableTable from '../../SortableTableDashboard'
import Modal from '../../Modal'
import Loading from '../../Loading'
import FeedbackInbox from '../../v2/FeedbackInbox'
import FilterBar from '../../v2/FilterBar'
import { ajaxFeedbackStatusFilter, setFeedbackStatus } from '../../redux/FeedbackRedux'

class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        props.dispatch(ajaxFeedbackStatusFilter(props.state, "All"));
        props.dispatch(setFeedbackStatus("All"));
    }

    render() {
        return (
            <div className="container-fluid dashboard-container">
                <Loading location={'page'} />
                <div className="row dashboard-stats sortable-table">
                    <DashboardActionBar />
                    {/* <StatsBar /> */}

                    {/* Always show MSA Locations Table */}
                    <SortableTable />

                    <SearchBar title="All Open Feedbacks" searchType="standard" />
                </div>
                <div className="mb-5">
                    {this.props.state.initial_feedbacks !== null &&
                        <>
                            <FilterBar />
                            <FeedbackInbox />
                            <FilterBar position="bottom" />
                        </>
                    }
                </div>
                <Modal modal={this.props.state.modal} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(Dashboard)
